import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import moment from 'moment';
import { EventsProvider, coEventsParameters } from '../../providers/events/events';
import { NavController, PopoverController, ModalController, Events, LoadingController } from 'ionic-angular';
import { ConfigProvider } from '../../providers/config/config';
import { LocationsProvider } from '../../providers/locations/locations';
import { ClientDetailsProvider } from '../../providers/client-details/client-details';
import { Platform } from 'ionic-angular/platform/platform';
import { CoWeekCalendarViewComponent } from '../co-week-calendar-view/co-week-calendar-view';
import { AppState } from '../../config/state';
import { FilteringProvider } from '../../providers/filtering/filtering';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { SoundsProvider } from '../../providers/sounds/sounds';
import { CoEventDetailsComponent } from '../co-event-details/co-event-details';
/**
 * Generated class for the CoEventsWeekComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-events-week',
  templateUrl: 'co-events-week.html',
  inputs: ['popOverFilter', 'currentDate']

})
export class CoEventsWeekComponent {
  density3Array: any[];
  density3Object: any;
  eventsQueryArgs: string;
  weekEvents: Array<coEventsParameters>;
  searchTags: any;
  showKeywordBox: boolean = false;
  searchForKeyword: string = "";
  // calendarLine: Array<string> = [];
  @Input('currentDate') currentWeek: any; //not actually current week but the the current date within the week
  @Output() onDatePicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() currentDensityForFilters: EventEmitter<any> = new EventEmitter<any>();
  @Output() eventQueryTimeArgs: EventEmitter<any> = new EventEmitter<any>();
  @Output() keywordSearchEmit: EventEmitter<any> = new EventEmitter<any>();
  @Input('popOverFilter') popOverFilter: any;
  @Input('currentFilters') currentFilters;
  @ViewChild('eventView') eventView;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;
  eventsCheck: boolean = true;
  startingDay: any;
  endingDay: any;
  filteredWeek: any;
  checkLast: number = 0;
  rawQueryData: any;
  currentDensity: number;
  lastEventTime: string = '';
  clientKeyword: string;
  viewType: string;
  screenWidth: any = this.platform.width();
  aboveWidthBreakpoint: boolean;
  timezone: number;
  pageLoaded: boolean = false;
  public devWidth = this.platform.width();
  @ViewChild(CoWeekCalendarViewComponent) innerCalendar: CoWeekCalendarViewComponent;

  constructor(public eventsProvider: EventsProvider, public locationsProvider: LocationsProvider, public config: ConfigProvider, public navCtrl: NavController, private clientDetails: ClientDetailsProvider, public platform: Platform, public state: AppState, public modalCtrl: ModalController, public popoverCtrl: PopoverController, public filteringProvider: FilteringProvider, private events: Events, private loadingCtrl: LoadingController, private sounds : SoundsProvider) {
    let self = this;
    this.clientDetails.load().then(function (response) {
      self.clientKeyword = response.keyword;
      self.viewType = state.mode;
      self.screenWidth = self.platform.width();
      self.timezone = response.timezone[0].offset;
      self.platform.width() > 992 ? self.aboveWidthBreakpoint = true : self.aboveWidthBreakpoint = false;
    });
  }

  ngOnInit() {
    this.eventsQueryArgs = `startDate: "${moment(this.currentWeek).startOf('week').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(this.currentWeek).endOf('week').format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(this.eventsQueryArgs);
    // this.calendarLoad(moment(this.currentWeek).format("YYYY-MM-DD HH:mm:ss"));
    this.startingDay = moment(this.currentWeek).startOf('week').format("YYYY-MM-DD HH:mm:ss");
    this.endingDay = moment(this.currentWeek).endOf('week').format("YYYY-MM-DD HH:mm:ss");
    if (this.currentFilters.keyword && this.currentFilters.keyword.length > 0){
      this.showKeywordBox = true;
      this.searchForKeyword = this.currentFilters.keyword;
    }
    const appRootIos = document.querySelector('.app-root-ios');
    if (appRootIos) {
      for(let x=0; x<10; x++){
        setTimeout(() => {
          appRootIos['style']['zIndex'] = appRootIos['style']['zIndex'] === '1' ? '2' : '1';
        }, x * 400);
      }
    }
  }
  ngAfterViewInit(): void {
    this.sounds.playSoundOnButtonClick();
  }
  ngOnDestroy(){
    this.events.unsubscribe('updateAllEvents');
  }
  resetWeekView(date) {
    this.eventsQueryArgs = `startDate: "${moment(date).startOf('week').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment(date).endOf('week').format("YYYY-MM-DD HH:mm:ss")}"`;
    this.queryEvents(this.eventsQueryArgs);
    // this.calendarLoad(moment(date).format("YYYY-MM-DD HH:mm:ss"));
    this.startingDay = moment(date).startOf('week').format("YYYY-MM-DD HH:mm:ss");
    this.endingDay = moment(date).endOf('week').format("YYYY-MM-DD HH:mm:ss");
  }

  updateBrochureStartDay(date) {
    this.eventQueryTimeArgs.emit({ start: moment(date).startOf('week').format("YYYY-MM-DD HH:mm:ss"), end: moment(date).endOf('week').format("YYYY-MM-DD HH:mm:ss") });
  }

  updateKeywordFilter(){
    if (this.searchForKeyword.length > 0) this.keywordSearchEmit.emit({keyword: this.searchForKeyword})
  }

  cancelKeywordFilter(){
    this.keywordSearchEmit.emit({keyword: ''})
  }
  goToEventDetails(eventId) {
    this.config.load(this.state.appId).then(cfg => {
      this.navCtrl.push(CoEventDetailsComponent, { eventId: eventId });
    });
  }
  queryEvents(args) {
    let eventsResponse;
    let loader = this.loadingCtrl.create({
      content:"Retrieving events..."
    });
    loader.present();
    this.eventsProvider.getEvents(args).then((res) => {
      this.updateBrochureStartDay(this.currentWeek);
      let allEvents = [];
      this.events.subscribe('updateAllEvents', async () => {
        allEvents = await this.eventsProvider.checkInterestedEvents(res);
      });
      res.allEvents.map((event) => {
        moment(event.eventStart, "dddd, MMMM D, YYYY hh:mm A").subtract(this.timezone, 'hours').format("YYYY-MM-DD HH:mm:ss");
        moment(event.eventEnd, "dddd, MMMM D, YYYY hh:mm A").subtract(this.timezone, 'hours').format("YYYY-MM-DD HH:mm:ss");
        allEvents.push(event)
      });
      eventsResponse = allEvents;
      this.rawQueryData = allEvents;
      this.filteredWeek = allEvents;
      this.searchTags = res.searchTypes;
      this.pageLoaded = true;
      this.splitByDay(eventsResponse)
      res.allEvents.length > 0 ? this.eventsCheck = true : this.eventsCheck = false;

      this.createDensityThreeArray();
      this.filterByPopOver(this.popOverFilter);
      loader.dismiss().catch(err=>{});
    });
  }
  createDensityThreeArray(){
    // console.log(this.weekEvents)
    this.density3Object = this.weekEvents.reduce((red, event) => {
      let currentEventTime = moment(event.eventStart).format("YYYY-DDD HH");
      if (!red[currentEventTime]) red[currentEventTime] = [];
      red[currentEventTime].push(event);
      return red;
    }, {});

    this.density3Array = Object.keys(this.density3Object).map((key) => {
      return this.density3Object[key];
    });
  }
  splitByDay(info) {
    // info.length > 0 ? this.eventsCheck = true: this.eventsCheck = false;
    // let filtered = [[], [], [], [], [], [], []];
    // info.forEach((event) => {
    //   filtered.forEach((arr, i) => {
    //     if (i.toString() === moment(event.eventStart).day().toString()) {
    //       arr.push(event)
    //     }
    //   });
    // });
    this.weekEvents = info;
    if (this.currentDensity === 3) this.createDensityThreeArray();
  }

  filterByPopOver(filterObj) {
    if (this.viewType === 'app' || (this.currentDensity === 1 || this.currentDensity === 2)) {
      this.filteringProvider.filterByPopover(filterObj, this.rawQueryData).then((res) => {
        this.splitByDay(res);
      })
    } else {
      this.innerCalendar.filterByPopOver(filterObj);
    }
  }

  // calendarLoad(date: string) {

  //   let selectedDate = moment(date).subtract(2, 'week').format("YYYY-MM-DD HH:mm:ss");
  //   this.calendarLine = [];
  //   for (let x = 0; x < 5; x++) {
  //     this.calendarLine.push(moment(selectedDate).add(x, 'week').format("YYYY-MM-DD HH:mm:ss"))
  //   };
  // };

  weekClicked(dateString: string) {
    let startDate = moment(dateString).startOf('week').format("YYYY-MM-DD HH:mm:ss");
    let endDate = moment(dateString).endOf('week').format("YYYY-MM-DD HH:mm:ss");
    // this.startingDay = moment(startDate).add(1, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.startingDay = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
    this.endingDay = endDate;
    this.eventsQueryArgs = `startDate: "${startDate}", endDate: "${endDate}"`;
    this.queryEvents(this.eventsQueryArgs);
    // this.calendarLoad(dateString);
    this.onDatePicked.emit(dateString);
    if (this.innerCalendar) {
      this.innerCalendar.initializeCalendar(dateString);
    }
  }

  nextWeek() {
    let selectedDate = moment(this.startingDay).add(1, 'week').format("YYYY-MM-DD HH:mm:ss");


    //save incase Paul wants to revert to old way
    // this.calendarLine = [];
    // for (let x = 0; x < 5; x++) {
    //   this.calendarLine.push(moment(selectedDate).add(x, 'week').format("YYYY-MM-DD HH:mm:ss"));
    // }
    // selectedDate = moment(selectedDate).add(3, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.weekClicked(selectedDate);
    this.onDatePicked.emit(selectedDate);
  }

  previousWeek() {
    let selectedDate = moment(this.startingDay).subtract(1, 'week').format("YYYY-MM-DD HH:mm:ss");
    // this.calendarLine = [];
    // for (let x = 0; x < 5; x++) {
    //   this.calendarLine.push(moment(selectedDate).add(x, 'week').format("YYYY-MM-DD HH:mm:ss"));
    // }
    // selectedDate = moment(selectedDate).add(3, 'day').format("YYYY-MM-DD HH:mm:ss");
    this.weekClicked(selectedDate);
    this.onDatePicked.emit(selectedDate);
  }

  updateDensity(density: number) {
    let className = "density" + density.toString();
    // let allEventViews = document.getElementsByClassName('eventView');
    let allEventViews = this.eventView.nativeElement;
    allEventViews.className = (className + " eventView");
    this.currentDensity = density;
    this.currentDensityForFilters.emit(density);
    if (this.pageLoaded && this.virtualScroller){
      this.virtualScroller.scrollToPosition(0, 100);
    }
  }

  checkLastDate(eventTime: string) {

    //if no last event
    if (this.lastEventTime == '') {
      this.lastEventTime = eventTime;
      return true;
    }

    //if they are the same, skip the day header
    if (moment(eventTime).day() == moment(this.lastEventTime).day()) {
      return false;
    }

    //if not, render the new day of week
    this.lastEventTime = eventTime;
    return true;
  }

  differentMonthCheck(weekStart: any, weekEnd: any) {
    if (moment(weekStart).month() == moment(weekEnd).month()) {
      return true;
    }

    return false;
  };

  screenWidthAboveBP() {
    if (this.platform.width() > 992) {
      return true;
    } else {
      return false;
    };
  };

  getEventColor(eventType, barOrText) {
    if (barOrText == 'text') {
      try {
        let eventTypeObject = this.searchTags.find(object => object.name === eventType);
        return eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    } else {
      try {
        let eventTypeObject = this.searchTags.find(object => object.name === eventType);
        return "2px solid " + eventTypeObject.color;
      } catch (ex) {
        return "green";
      };
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-events-week/co-events-week.ts